import { Link } from "react-router-dom";

const POLICIES = [
  ["Privacy Policy", "privacy"],
  ["Terms of Service", "terms"],
  ["Repair Terms", "repair-terms"],
  ["Warranty", "warranty"],
  ["Parts & Cancellation Policy", "parts-cancellation"],
  ["Appointment Policy", "appointment"],
  ["Accessibility", "accessibility"],
  ["Contact", "contact"],
];

export default function Footer() {
  const reg = process.env.REACT_APP_CA_ESD_REG || "";
  return (
    <footer className="border-t border-slate-200 bg-white mt-16" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="font-heading font-extrabold text-lg text-slate-900">THE REPAIR NOOK</div>
          <div className="italic text-amber-700 text-sm mt-1">Fix It. Don't Ditch It.</div>
          <div className="mt-4 text-sm text-slate-600 space-y-1">
            <div>Phone: <a href="tel:5307173878" className="hover:text-slate-900">(530) 717-3878</a></div>
            <div>Email: <a href="mailto:repairnook@gmail.com" className="hover:text-slate-900">repairnook@gmail.com</a></div>
            <div>Serving Glenn County & surrounding areas, California</div>
          </div>
          {reg && (
            <div className="mt-4 text-xs text-slate-500" data-testid="footer-ca-reg">
              California Electronic Service Dealer Reg. No. {reg}
            </div>
          )}
        </div>
        <div className="grid grid-cols-2 gap-2 text-sm md:col-span-2">
          {POLICIES.map(([label, slug]) => (
            <Link key={slug} to={`/policy/${slug}`} data-testid={`footer-policy-${slug}`} className="text-slate-600 hover:text-slate-900">{label}</Link>
          ))}
        </div>
      </div>
      <div className="border-t border-slate-200 py-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} The Repair Nook · Quality replacement parts · 90-day warranty
      </div>
    </footer>
  );
}
